module.exports = __webpack_public_path__ + "static/media/AIS.106829cb.png";